import { c as _c } from "react/compiler-runtime";
import HospitalTag from "../HospitalTag";
import { PartnerHospitalTagCode } from "@/entities/hospital/api/types";
interface HospitalTagListProps {
  tags: PartnerHospitalTagCode[];
}
const HospitalTagList = t0 => {
  const $ = _c(4);
  const {
    tags
  } = t0;
  let t1;
  if ($[0] !== tags) {
    t1 = tags.map(_temp);
    $[0] = tags;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="flex gap-1">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default HospitalTagList;
function _temp(tag, index) {
  return <HospitalTag key={`hospital-tag-${tag}-${index}`} tag={tag} />;
}